// frontend/src/components/shared/OfflineIndicator.tsx
// MOB-06: Offline indicator + graceful degradation
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';
import './OfflineIndicator.css';

export const OfflineIndicator: React.FC = () => {
  const { t } = useTranslation();
  const { isOnline, wasOffline, dismissReconnected } = useOnlineStatus();
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (wasOffline && isOnline) {
      setShowReconnected(true);
      const timer = setTimeout(() => {
        setShowReconnected(false);
        dismissReconnected();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [wasOffline, isOnline, dismissReconnected]);

  if (isOnline && !showReconnected) return null;

  return (
    <div
      className={`offline-indicator ${isOnline ? 'offline-indicator--reconnected' : 'offline-indicator--offline'}`}
      role="status"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="offline-indicator__content">
        {!isOnline ? (
          <>
            <span className="offline-indicator__icon" aria-hidden="true">⚡</span>
            <span className="offline-indicator__text">
              {t('offlineMessage', 'You are offline. Some features may be unavailable.')}
            </span>
          </>
        ) : (
          <>
            <span className="offline-indicator__icon" aria-hidden="true">✓</span>
            <span className="offline-indicator__text">
              {t('onlineReconnected', 'Back online!')}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;
